import React, { useEffect, useState } from "react";
import PermissionsPage from "../../components/settings/permissions/PermissionsPage";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const Permissions = () => {
  const merchant = useSelector((state: RootState) => state?.merchant?.profile);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    setRole(localStorage.getItem("role"));
  }, []);

  const firstName = merchant?.firstName;

  return (
    <section>
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="w-full  bg-white shadow-lg rounded-xl p-6 text-center space-y-4">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Hello, {firstName || "User"}
          </h1>
          <p className="text-lg text-gray-600 mb-4">
            Your current role is{" "}
            <span className="font-semibold text-gray-800">
              {role || "Not Specified"}
            </span>
          </p>
        </div>
      </main>
      <PermissionsPage />
    </section>
  );
};

export default Permissions;
